import React, { Component } from 'react'
import {Link} from 'react-router';
import { get, isEmpty } from 'lodash';

class RowItemThongKeGiamSatNhapDonCu extends Component {

  getLinkRedirect(type) {
    const { donVi } = this.props.item;
    const { phanLoaiDon, nguonDon } = this.props;
    let result = `/theo-doi-giam-sat/danh-sach-thong-ke-giam-sat-don-cu/${get(donVi, 'id')}/${get(this.props.item, 'donVi.tenDonVi')}/${type}`
    if (!isEmpty(phanLoaiDon) && !isEmpty(nguonDon)) {
      result = result + `?phanLoaiDon=${phanLoaiDon}&nguonDon=${nguonDon}`
    } else if (!isEmpty(phanLoaiDon) && isEmpty(nguonDon)) {
      result = result + `?phanLoaiDon=${phanLoaiDon}`
    } else if (isEmpty(phanLoaiDon) && !isEmpty(nguonDon)) {
      result = result + `?nguonDon=${nguonDon}`
    } else {
      return result;
    }
    return result;
  }

  render() {
    const { soDonDonGian, soDonPhucTap, soDon} = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td  className='list-items-table'>
          {
            this.props.item && this.props.item.coDonViCon === true ?
              <Link to={'/theo-doi-giam-sat/thong-ke-giam-sat-nhap-don-cu/' + this.props.item.donVi.id }>{this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''}</Link>
              :
              <span>{this.props.item.donVi ? this.props.item.donVi.tenDonVi : ''}</span>
          }
        </td>
        <td>{soDonDonGian > 0 ? <Link to={this.getLinkRedirect('DON_GIAN')}>{soDonDonGian}</Link> : soDonDonGian}</td>
        <td>{soDonPhucTap > 0 ? <Link to={this.getLinkRedirect('PHUC_TAP')}>{soDonPhucTap}</Link> : soDonPhucTap}</td>
        <td>{soDon}</td>
      </tr>
    )
  }
}

export default RowItemThongKeGiamSatNhapDonCu;


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/datatable/RowItemThongKeGiamSatNhapDonCu.jsx